module.exports = __webpack_public_path__ + "img/empty.b1c09e0d.png";